export const methods = [
	{
		key: 'GET',
		value: 'GET',
	},
	{
		key: 'POST',
		value: 'POST',
	},
	{
		key: 'PUT',
		value: 'PUT',
	},
	{
		key: 'DELETE',
		value: 'DELETE',
	},
] as const;

export const algorithms = [
	{
		key: 'AES-128-CFB',
		value: 'AES-128-CFB',
	},
	{
		key: 'AES-192-CFB',
		value: 'AES-192-CFB',
	},
	{
		key: 'AES-256-CFB',
		value: 'AES-256-CFB',
	},
	{
		key: 'AES-128-GCM',
		value: 'AES-128-GCM',
	},
	{
		key: 'AES-192-GCM',
		value: 'AES-192-GCM',
	},
	{
		key: 'AES-256-GCM',
		value: 'AES-256-GCM',
	},
];

export enum ProfileStatus {
	INACTIVE = 0,
	ACTIVE = 1,
	DISABLED = 2,
	AUTO_DISABLED = 3,
	DELETED = 9,
}

export const IV_LENGTH = 16;


export const  authHttpMethods = [
	{
		key: 'POST',
		value: 'POST',
	}
]

export const authType = [
	{
		key: 'Oauth 2.0',
		value: 'Oauth 2.0',
	}
]

export type DynamicResponse = {
	data: { channels: ChannelDynamicVariable[] };
};

export type ChannelDynamicVariable = {
	source: string;
	description: string;
	events: DynamicEvent[];
};

export type DynamicEvent = {
	name: string;
	description: string;
	variables: DynamicVariable[];
};

export type DynamicVariable = {
	name: string;
	description: string;
	methods: string[];
};

export const defaultChannel = 'Default';
export const defaultResponse = {
	source: defaultChannel,
	description: 'No channel selected',
};
